import { RelationShipTypeViewModel, RelationShipTypeCreateCommand, RelationShipTypeUpdateCommand } from '../../models/Entities/Person/RelationshipType/RelationshipTypeModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_RELATIONSHIP_TYPE_GETALL_REQUEST = 'PERSON_RELATIONSHIP_TYPE_GETALL_REQUEST';
export const PERSON_RELATIONSHIP_TYPE_GETALL_SUCCESS = 'PERSON_RELATIONSHIP_TYPE_GETALL_SUCCESS';
export const PERSON_RELATIONSHIP_TYPE_GETALL_FAILURE = 'PERSON_RELATIONSHIP_TYPE_GETALL_FAILURE';

export interface PersonRelationshipTypeGetAllRequestAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_GETALL_REQUEST;
}

export interface PersonRelationshipTypeGetAllSuccessAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_GETALL_SUCCESS;
    payload: RelationShipTypeViewModel[];
}

export interface PersonRelationshipTypeGetAllFailureAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_RELATIONSHIP_TYPE_GETBYID_REQUEST = 'PERSON_RELATIONSHIP_TYPE_GETBYID_REQUEST';
export const PERSON_RELATIONSHIP_TYPE_GETBYID_SUCCESS = 'PERSON_RELATIONSHIP_TYPE_GETBYID_SUCCESS';
export const PERSON_RELATIONSHIP_TYPE_GETBYID_FAILURE = 'PERSON_RELATIONSHIP_TYPE_GETBYID_FAILURE';

export interface PersonRelationshipTypeGetByIdRequestAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_GETBYID_REQUEST;
    id: number;
}

export interface PersonRelationshipTypeGetByIdSuccessAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_GETBYID_SUCCESS;
    payload: RelationShipTypeViewModel;
}

export interface PersonRelationshipTypeGetByIdFailureAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_RELATIONSHIP_TYPE_CREATE_REQUEST = 'PERSON_RELATIONSHIP_TYPE_CREATE_REQUEST';
export const PERSON_RELATIONSHIP_TYPE_CREATE_SUCCESS = 'PERSON_RELATIONSHIP_TYPE_CREATE_SUCCESS';
export const PERSON_RELATIONSHIP_TYPE_CREATE_FAILURE = 'PERSON_RELATIONSHIP_TYPE_CREATE_FAILURE';

export interface PersonRelationshipTypeCreateRequestAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_CREATE_REQUEST;
    payload: RelationShipTypeCreateCommand;
}

export interface PersonRelationshipTypeCreateSuccessAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_CREATE_SUCCESS;
    payload: RelationShipTypeViewModel;
}

export interface PersonRelationshipTypeCreateFailureAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_RELATIONSHIP_TYPE_UPDATE_REQUEST = 'PERSON_RELATIONSHIP_TYPE_UPDATE_REQUEST';
export const PERSON_RELATIONSHIP_TYPE_UPDATE_SUCCESS = 'PERSON_RELATIONSHIP_TYPE_UPDATE_SUCCESS';
export const PERSON_RELATIONSHIP_TYPE_UPDATE_FAILURE = 'PERSON_RELATIONSHIP_TYPE_UPDATE_FAILURE';

export interface PersonRelationshipTypeUpdateRequestAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_UPDATE_REQUEST;
    payload: RelationShipTypeUpdateCommand;
}

export interface PersonRelationshipTypeUpdateSuccessAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_UPDATE_SUCCESS;
    payload: RelationShipTypeViewModel;
}

export interface PersonRelationshipTypeUpdateFailureAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_RELATIONSHIP_TYPE_DELETE_REQUEST = 'PERSON_RELATIONSHIP_TYPE_DELETE_REQUEST';
export const PERSON_RELATIONSHIP_TYPE_DELETE_SUCCESS = 'PERSON_RELATIONSHIP_TYPE_DELETE_SUCCESS';
export const PERSON_RELATIONSHIP_TYPE_DELETE_FAILURE = 'PERSON_RELATIONSHIP_TYPE_DELETE_FAILURE';

export interface PersonRelationshipTypeDeleteRequestAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_DELETE_REQUEST;
    id: number;
}

export interface PersonRelationshipTypeDeleteSuccessAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_DELETE_SUCCESS;
    id: number;
}

export interface PersonRelationshipTypeDeleteFailureAction {
    type: typeof PERSON_RELATIONSHIP_TYPE_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
